// extracted by mini-css-extract-plugin
export default {"center":"GridContainer_center__p0llJ","side":"GridContainer_side__IGVxA"};